import { render, staticRenderFns } from "./ExportTemplateMappings.vue?vue&type=template&id=76746e40"
import script from "./ExportTemplateMappings.vue?vue&type=script&lang=js"
export * from "./ExportTemplateMappings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports